export default __webpack_public_path__ + "images/assets/6faf67cb8aedbf0df4639a5f7880140f.svg";